import { SocialSharePodcastEpisode } from './types';
import VideosByEpisodeTable from './VideosByEpisode';

export default VideosByEpisodeTable;
export type { SocialSharePodcastEpisode };
